import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Redirect, Route, Switch } from 'react-router-dom';

import { getUser } from './redux/actions';
import { hasActiveSubscription, hasMsAdminAccess } from './subscription/redux/selectors';
import Toast from './layout/Toast';
import Header from './layout/Header';
import Footer from './layout/Footer';
import PrivateRoute from './common/auth/PrivateRoute';
import Loading from './common/components/Loading';
import Login from './common/auth/Login';
import Logout from './common/auth/Logout';
import StyleGuide from './style-guide/StyleGuidePage';
import Subscription from './subscription/Subscription';
import Subscribe from './Subscribe';
import sendInfoToIntercom from './common/utils/sendInfoToIntercom';
import GiftSubscription from './GiftSubscription';
import AffiliateSignUp from './AffiliateSignUp';
import store from 'store2';
import config from './config';
import getDecodedToken from './common/auth/utils/getDecodedToken';

class App extends Component {
  state = {
    isMobileNavOpen: false,
    isAccountNavOpen: false,
    isLoadingUser: true,
  };

  componentDidMount() {
    const { user, courses } = this.props;

    sendInfoToIntercom(user, courses, 'boot');

    if (store.get(config.auth.idTokenKey) && !user.get('loaded')) {
      const userId = getDecodedToken().sub;
      this.props.dispatch(getUser(userId)).then(() => {
        this.setState({ isLoadingUser: false });
      });
    } else {
      this.setState({ isLoadingUser: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.path !== nextProps.match.path) {
      window.gtag && window.gtag('send', 'pageview', nextProps.match.path);
    }

    if (nextProps.location !== this.props.location) {
      this.setState({
        isMobileNavOpen: false,
        isAccountNavOpen: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { user, courses } = this.props;
    const subscriptions = user.getIn(['data', 'subscriptions']),
      prevSubscriptions = prevProps.user.getIn(['data', 'subscriptions']);
    if (
      (!prevProps.user.get('loaded') && user.get('loaded')) ||
      subscriptions !== prevSubscriptions ||
      prevProps.courses !== courses
    ) {
      sendInfoToIntercom(user, courses, 'update');
    }
  }

  componentWillUnmount() {
    window.Intercom('shutdown');
  }

  getEnvironmentDependentRoutes = () => {
    const routes = [];

    if (process.env.NODE_ENV !== 'production') {
      routes.push(<Route exact path="/styleguide" component={StyleGuide} key="style-guide" />);
    }

    return routes;
  };

  toggleMobileNav = () => {
    this.setState({
      isMobileNavOpen: !this.state.isMobileNavOpen,
    });
  };

  toggleAccountNav = () => {
    this.setState({
      isAccountNavOpen: !this.state.isAccountNavOpen,
    });
  };

  onCloseUnderlay = () => {
    this.setState({
      isMobileNavOpen: false,
      isAccountNavOpen: false,
    });
  };

  renderFooter = () => {
    if (this.props.location.pathname === '/subscription/coaching/movement-specialists') {
      return null;
    }

    return <Footer isMobile={this.props.isMobile} location={this.props.location} />;
  };

  render() {
    const { location, user } = this.props;
    const mainLayoutClasses = {
      'main-layout': true,
      'mobile-nav--open': this.state.isMobileNavOpen,
      'account-nav--open': this.state.isAccountNavOpen,
      'mileageplus': this.props.location.pathname === '/mileageplus'
    };

    if (this.state.isLoadingUser) {
      return <Loading />;
    }

    return (
      <div className={classNames(mainLayoutClasses)}>
        <Toast />
        <Header
          hasActiveSubscription={this.props.hasActiveSubscription}
          hasMsAdminAccess={this.props.hasMsAdminAccess}
          isMobile={this.props.isMobile}
          isMobileNavOpen={this.state.isMobileNavOpen}
          toggleMobileNav={this.toggleMobileNav}
          isAccountNavOpen={this.state.isAccountNavOpen}
          toggleAccountNav={this.toggleAccountNav}
          onCloseUnderlay={this.onCloseUnderlay}
          location={location}
          userLoaded={user.get('loaded')}
        />
        <div className="main-layout__children">
          <Switch>
            {this.getEnvironmentDependentRoutes()}
            <Route exact path="/" component={Subscribe} />
            <Route exact path="/trial" component={Subscribe} />
            <Route exact path="/mileageplus" component={Subscribe} />
            <Route exact path="/gift-subscription" component={GiftSubscription} />
            <Route exact path="/affiliate" component={AffiliateSignUp} />
            <Route exact path="/login" component={Login} />
            <PrivateRoute exact path="/logout" component={Logout} />
            <PrivateRoute path="/subscription" component={Subscription} />
            <Redirect to="/" />
          </Switch>
        </div>
        {this.renderFooter()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.browser.lessThan.desktop,
  hasMsAdminAccess: hasMsAdminAccess(state),
  hasActiveSubscription: hasActiveSubscription(state),
  user: state.subscription.user,
  courses: state.subscription.courses.courses,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js